'use client';
import useWindowSize from '@/utils/useScreenSize';
import { ImagePreviewGroup } from '../ImagePreview';
import { AlbumSimpleImageSlider, Slider, SliderControlButton } from '../Slider';
import { mobileBreakPoint } from '@/utils/utils';

interface Props {
    content: any;
    data: {
        partyDateFolder: any;
        partyDetail: any;
        partyInformation: any;
    };
}
/** 适用于 pageDetail-partyAlbum  */
const PartyAlbum = (props: Props) => {
    // console.log('partyAlbum----', props);
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < mobileBreakPoint;

    const sliderSetting = !isMobile
        ? {
              slidesPerView: 6,
              spaceBetween: 0,
              centeredSlides: false,
          }
        : {
              spaceBetween: 10,
              centeredSlides: true,
              slidesPerView: 1.8,
          };

    const slideTo = isMobile && props.content?.albumList.length > 3 ? 1 : 0;

    const imageList = (props.content?.albumList || []).map((item: any, index: number) => {
        return {
            src: item.contentImage?.src,
            mediaType: item.mediaType?.value,
            videoSrc: item.videoSrc?.value,
            mediaCaption: item.mediaCaption?.value,
            id: index,
        };
    });

    return (
        <ImagePreviewGroup imageList={imageList} total={(props.content?.albumList || []).length}>
            <Slider settings={sliderSetting} className='w-full my-5' slideTo={slideTo}>
                {AlbumSimpleImageSlider(props.content?.albumList || [])}
                <SliderControlButton className='max-xmd:mt-6 xmd:mt-7 mb-[18px]' />
            </Slider>
        </ImagePreviewGroup>
    );
};

export default PartyAlbum;
